export default {
    props: {
        useExitModal: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            exitModal: false,
        };
    },
    methods: {
        attemptExit() {
            if (this.useExitModal) {
                this.exitModal = true;
            } else {
                this.continueToExit();
            }
        },
        preventExit() {
            this.exitModal = false;
        },
    },
}